import {createContext} from 'react'

const placeContext = createContext()

export default placeContext
